// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderCellWrapper_wrapper__3m8e0"};